var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16016 9.15895C9.03164 9.05504 8.96875 8.88824 8.96875 8.71871C8.96875 8.54918 9.03284 8.38293 9.16101 8.25469L11.7605 5.65621H0.65625C0.293945 5.65621 0 5.3609 0 4.97535C0 4.63629 0.293945 4.34371 0.65625 4.34371H11.7605L9.16207 1.74524C8.90572 1.48889 8.90572 1.07367 9.16207 0.81719C9.41842 0.560706 9.83363 0.560842 10.0901 0.81719L13.8089 4.53594C14.0652 4.79229 14.0652 5.2075 13.8089 5.46399L10.0901 9.18274C9.83281 9.43785 9.41719 9.43785 9.16016 9.15895Z",
    fill: "#A5AAB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.0238fb918503fd24104f4c98b8d99e67.svg";
export { ForwardRef as ReactComponent };